import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PURPLE } from '../../utils/designUtils';

const RegisterForm = () => {
  const navigate = useNavigate();

  const outlineBtn = {
    display: 'block', width: '100%', padding: '14px 20px', borderRadius: 10,
    border: `1.5px solid ${PURPLE}`, color: PURPLE, background: 'transparent',
    fontWeight: 600, fontSize: 15, cursor: 'pointer', textAlign: 'left'
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f4fa' }}>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(124,107,217,0.10)', border: '1px solid rgba(124,107,217,0.12)', padding: '40px', width: '100%', maxWidth: 480 }}>
        <h2 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 28, color: '#1f1d2e', fontSize: 20 }}>
          회원 등록 유형을 선택해주세요
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <button style={outlineBtn} onClick={() => navigate('/create/orgUser')}>조직 (사업자) 등록</button>
          <button style={outlineBtn} onClick={() => navigate('/create/notOrgUser')}>조직 (비사업자) 등록</button>
          <button style={outlineBtn} onClick={() => navigate('/create/user')}>회원 등록</button>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
